app
    .controller('CoachImageFormCtrl', function CoachImageFormCtrl($http, $scope, $filter) {
        $scope.error = '';
        this.save = () => {
            const formData = new FormData();
            // const file = document.getElementById('profilePic').files[0];
            const fileUpload = document.getElementById('profilePic');
            
            var regex = new RegExp("([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.gif)$");
            if (regex.test(fileUpload.value.toLowerCase())) {
                // check weather HTML5 is supported.
                if (typeof (fileUpload.files) != "undefined") {
                    // Initiate the FileReader object.
                    var reader = new FileReader();
                    // Read the contents of Image File.
                    reader.readAsDataURL(fileUpload.files[0]);
                    thisObj = this;
                    reader.onload = function (e) {
                        //Initiate the JavaScript Image object.
                        var image = new Image();
                        //Set the Base64 string return from FileReader as source.
                        image.src = e.target.result;
                        image.onload = function () {
                            //Determine the Height and Width.
                            var height = this.height;
                            var width = this.width;
                            if (height > 2000 || width > 2000) {
                                $scope.$apply(function() {
                                    $scope.error = $filter('translate')('modal.coachImageForm.notExceed');
                                });
                                return false;
                            } else if (height < 1080 || width < 1080) {
                                $scope.$apply(function() {
                                    $scope.error = $filter('translate')('modal.coachImageForm.imageMust1080');
                                });
                                return false;
                            }
                            $scope.$apply(function() {
                                $scope.error = '';
                            });
                            formData.append('profilePic', fileUpload.files[0]);
                            $http.post('/profile/picture', formData, {
                                headers: {'Content-Type': undefined}
                            }).then(() => {
                                thisObj.close();
                            });
                        };
                    };
                } else {
                    $scope.error = $filter('translate')("modal.coachImageForm.notSuppportHTML5");
                    return false;
                }
            } else {
                $scope.error = $filter('translate')("modal.coachImageForm.selectValidFile");
                return false;
            }
        };

        $scope.chooseFile = $filter('translate')("modal.editPicture.label.chooseFile");

        this.cancel = () => {
            this.dismiss();
        };
    })
    .component('coachImageForm', {
        template: `
        <form name="pictureForm" ng-submit="pictureForm.$valid && $ctrl.save()">
            <div class="modal-header">
                <h3 class="modal-title" id="modal-title">
                <chat-icon type="picture" width="24"/>{{ 'modal.editPicture.title' | translate}}
                </h3>
                <button type="button" class="btn btn-close" ng-click="$ctrl.cancel()">
                    <chat-icon type="cross" width="15" />
                </button>
            </div>
            <div class="modal-body" id="modal-body">
                <div class="form-group">
                    <label class="custom-file form-control sg-custom-file">
                        <input type="file" id="profilePic" class="custom-file-input" required />
                        <label for="dp" class="custom-file-label">{{ chooseFile }}</label>
                    </label>
                    <span class="form-text text-muted"><small>{{ 'modal.editPicture.helpText.image' | translate}}</small></span>
                    <p class="form-text text-danger" ng-if="error">{{ error }}</p>
                </div>
            </div><div class="modal-footer">
                <button class="btn btn-save" type="submit" ng-click="$ctrl.ok()">{{ 'modal.editPicture.button.save' | translate}}</button>
            </div>
        </form>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'CoachImageFormCtrl'
    });
